import { FlightData } from './types'

function fireEvent (eventName: string, sourceId: string, targetId: string, paramObj: Partial<ParamsObj>) {
  try {
    if (parent.FVWebComponent) {
      parent.FVWebComponent.fireEvent(eventName, sourceId, targetId, paramObj)
    }
  } catch (e) {
    console.log('not wrapped by us')
  }
}

// used for compatibility with old FVAccess
export function fvaxSignal (eventName: string, why: string, custId: string, toolId: string, flight: FlightData) {
  const paramObj: Partial<ParamsObj> = {}
  paramObj.toolType = 'FVACCESS_TRACKER'
  paramObj.state = 'TRACKER_INDIVIDUAL'
  paramObj.qtype = 'SingleFlight'
  paramObj.custId = custId
  paramObj.toolId = toolId
  paramObj.why = why
  if (flight) {
    paramObj.depap = flight.departureAirport.code
    paramObj.depdate = flight.departureAirport.scheduled?.toISOString().substring(0, 10)
    paramObj.depdateUtc = flight.departureAirport.utc.scheduled?.toISOString().substring(0, 10)
    paramObj.deptimeUtc = flight.departureAirport.utc.scheduled?.toISOString().substring(11, 19)
    paramObj.bestDepTime = flight.departureAirport.utc.time
    paramObj.arrap = flight.arrivalAirport.code
    paramObj.arrdateUtc = flight.arrivalAirport.utc.scheduled?.toISOString().substring(0, 10)
    paramObj.arrtimeUtc = flight.arrivalAirport.utc.scheduled?.toISOString().substring(11, 19)
    paramObj.mainAirlineName = flight.flightId.airlineName
    paramObj.mainAirlineCode = flight.flightId.airlineCode
    paramObj.mainFlightNumber = flight.flightId.flightNumber
    paramObj.operatorAirlineName = flight.flightId.codeShare?.airlineName
    paramObj.operatorAirlineCode = flight.flightId.codeShare?.airlineCode
    paramObj.operatorFlightNumber = flight.flightId.codeShare?.flightNumber
    paramObj.regionalAirlineName = flight.flightId.regionalCarrier?.airlineName
    paramObj.regionalAirlineCode = flight.flightId.regionalCarrier?.airlineCode
    paramObj.regionalFlightNumber = flight.flightId.regionalCarrier?.flightNumber
    paramObj.stati = '.' + flight.status.join('.')
    paramObj.numLegs = flight.numLegs || '1'
  }
  fireEvent(eventName, custId + '_' + toolId, null, paramObj)
}

export function fvAtmInitSignal (custId: string, toolId: string) {
  const paramObj: Partial<ParamsObj> = {}
  paramObj.toolType = 'FVACCESS_AIRTRAFFICMAP'
  paramObj.state = 'ATM_UNKNOWN'
  fireEvent('FVACCESS_INIT', custId + '_' + toolId, null, paramObj)
}

export function fvWlInitSignal (custId: string, toolId: string) {
  const paramObj: Partial<ParamsObj> = {}
  paramObj.toolType = 'FVACCESS_WEATHER'
  paramObj.custId = custId
  paramObj.toolId = toolId
  paramObj.state = 'WEATHER_0'
  fireEvent('FVACCESS_INIT', custId + '_' + toolId, null, paramObj)
}

interface ParamsObj {
  toolType: string
  custId: string
  toolId: string
  qtype: string
  state: string
  depap: string
  arrap: string
  depdate: string
  depdateUtc: string
  arrdateUtc: string
  deptimeUtc: string
  arrtimeUtc: string
  mainAirlineName: string
  mainAirlineCode: string
  mainFlightNumber: string
  operatorAirlineName: string
  operatorAirlineCode: string
  operatorFlightNumber: string
  regionalAirlineName: string
  regionalAirlineCode: string
  regionalFlightNumber: string
  bestDepTime: Date
  stati: string
  numLegs: string
  why: string
}

declare global {
  interface Window {
    FVWebComponent: any
  }
}
